(function () {
  var productCache = {};

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function optionName(product, index) {
    var option = product.options && product.options[index];
    return typeof option === 'string' ? option : option && option.name ? option.name : 'Option ' + (index + 1);
  }

  function variantOptionValue(variant, index) {
    return variant['option' + (index + 1)] || '';
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not load product ' + handle);
        return response.json();
      });
    }
    return productCache[handle];
  }

  function firstAvailableVariant(product) {
    return (product.variants || []).find(function (variant) {
      return variant.available;
    }) || (product.variants || [])[0];
  }

  function findDefaultVariant(product, defaultValue) {
    var wanted = normalize(defaultValue);
    if (!wanted) return null;
    return (product.variants || []).find(function (variant) {
      return variant.available && (
        normalize(variant.id) === wanted ||
        normalize(variant.sku) === wanted ||
        normalize(variant.title) === wanted
      );
    }) || (product.variants || []).find(function (variant) {
      return normalize(variant.id) === wanted ||
        normalize(variant.sku) === wanted ||
        normalize(variant.title) === wanted;
    }) || null;
  }

  function variantMatchesOptions(product, variant, selected) {
    return (product.options || []).every(function (_option, index) {
      var name = optionName(product, index);
      var wanted = selected[name];
      return !wanted || normalize(variantOptionValue(variant, index)) === normalize(wanted);
    });
  }

  function findVariant(product, selected) {
    return (product.variants || []).find(function (variant) {
      return variant.available && variantMatchesOptions(product, variant, selected);
    }) || (product.variants || []).find(function (variant) {
      return variantMatchesOptions(product, variant, selected);
    }) || firstAvailableVariant(product);
  }

  function variantSelectedOptions(product, variant) {
    var selected = {};
    (product.options || []).forEach(function (_option, index) {
      selected[optionName(product, index)] = variantOptionValue(variant, index);
    });
    return selected;
  }

  function finishKeyFromSelected(selected) {
    var joined = Object.keys(selected || {}).map(function (key) {
      return selected[key];
    }).join(' ').toLowerCase();
    if (joined.indexOf('gloss') !== -1) return 'glossy';
    if (joined.indexOf('matte') !== -1 || joined.indexOf('matt') !== -1) return 'matte';
    return '';
  }

  function swatchAsset(value) {
    var key = normalize(value).replace('gray', 'grey');
    var map = {
      'matte white': 'bf-swatch-matte-white.png',
      'glossy white': 'bf-swatch-glossy-white.png',
      'matte black': 'bf-swatch-black-matte.png',
      'glossy black': 'bf-swatch-black-glossy.png',
      'matte grey': 'bf-swatch-grey-matte.png',
      'glossy grey': 'bf-swatch-grey-glossy.png',
      'brushed steel': 'bf-swatch-brushed-steel.png',
      'brushed nickel': 'bf-swatch-brushed-steel.png',
      'chrome': 'bf-swatch-chrome.png',
      'polished chrome': 'bf-swatch-chrome.png',
      'gold': 'bf-swatch-brushed-gold.png',
      'brushed gold': 'bf-swatch-brushed-gold.png',
      'rose gold': 'bf-swatch-brushed-rose-gold.png',
      'brushed rose gold': 'bf-swatch-brushed-rose-gold.png',
      'dark oak': 'bf-swatch-dark-oak-walnut.png',
      'walnut': 'bf-swatch-dark-oak-walnut.png',
      'natural oak': 'bf-swatch-light-oak.png',
      'natural': 'bf-swatch-light-oak.png',
      'white': 'swatch-color-white.png',
      'black': 'swatch-color-black.png',
      'grey': 'swatch-color-gray.png'
    };
    return map[key] || '';
  }

  function colourSwatchAsset(colour, finishKey) {
    var key = normalize(colour);
    if (key === 'white') return finishKey === 'glossy' ? 'bf-swatch-glossy-white.png' : 'bf-swatch-matte-white.png';
    if (key === 'black') return finishKey === 'glossy' ? 'bf-swatch-black-glossy.png' : 'bf-swatch-black-matte.png';
    if (key === 'grey' || key === 'gray') return finishKey === 'glossy' ? 'bf-swatch-grey-glossy.png' : 'bf-swatch-grey-matte.png';
    return '';
  }

  function setAssetBackground(button, assetName) {
    if (!assetName) {
      button.style.backgroundImage = '';
      return;
    }
    var base = document.documentElement.dataset.bfAssetBase || '';
    button.style.backgroundImage = 'url(' + base + assetName + ')';
  }

  function updateCardTotals(root) {
    var currency = root.dataset.currency || 'USD';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-room-card]'));
    var total = 0;
    var selectedCount = 0;
    var totalEl = root.querySelector('[data-room-total]');
    var countEl = root.querySelector('[data-room-count]');
    var addButton = root.querySelector('[data-room-add]');

    cards.forEach(function (card) {
      var state = card._roomState;
      var checkbox = card.querySelector('[data-room-select]');
      var qty = Number(card.dataset.quantity || 0);
      var selected = checkbox && checkbox.checked && qty > 0 && state && state.variant && state.variant.available;
      card.classList.toggle('is-selected', !!selected);

      if (selected) {
        selectedCount += qty;
        total += Number(state.variant.price || 0) * qty;
      }
    });

    if (totalEl) totalEl.textContent = selectedCount > 0 ? money(total, currency) : 'Select pieces';
    if (countEl) countEl.textContent = selectedCount === 1 ? '1 item selected' : selectedCount + ' items selected';
    if (addButton) addButton.disabled = selectedCount === 0;
  }

  function updateCard(card, root) {
    var state = card._roomState;
    if (!state || !state.product || !state.variant) return;

    var product = state.product;
    var variant = state.variant;
    var currency = root.dataset.currency || 'USD';
    var image = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : product.featured_image;
    var imageEl = card.querySelector('[data-room-product-image]');
    var titleEl = card.querySelector('[data-room-product-title]');
    var priceEl = card.querySelector('[data-room-product-price]');
    var optionSummary = card.querySelector('[data-room-option-summary]');
    var stockEl = card.querySelector('[data-room-product-stock]');

    if (imageEl && image) {
      imageEl.src = image;
      imageEl.alt = product.title;
    }
    if (titleEl) titleEl.textContent = product.title;
    if (priceEl) priceEl.textContent = money(variant.price, currency);
    if (optionSummary) optionSummary.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    if (stockEl) stockEl.textContent = variant.available ? '' : 'Unavailable';

    renderOptionControls(card, root);
    updateCardTotals(root);
  }

  function renderColourControls(card, root) {
    var state = card._roomState;
    var wrap = card.querySelector('[data-room-colours]');
    if (!wrap || !state) return;

    var siblings = state.siblings || {};
    var entries = ['white', 'black', 'grey'].filter(function (key) {
      return siblings[key];
    });

    wrap.innerHTML = '';
    wrap.hidden = entries.length < 2;
    if (entries.length < 2) return;

    var finishKey = finishKeyFromSelected(state.selected);

    entries.forEach(function (key) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bf-room-set__swatch';
      button.dataset.colourHandle = siblings[key];
      button.setAttribute('aria-label', key.charAt(0).toUpperCase() + key.slice(1));
      button.classList.toggle('is-active', siblings[key] === state.product.handle);
      setAssetBackground(button, colourSwatchAsset(key, finishKey));
      button.addEventListener('click', function () {
        var previousFinish = finishKeyFromSelected(state.selected);
        fetchProduct(siblings[key]).then(function (newProduct) {
          var nextVariant = firstAvailableVariant(newProduct);
          if (previousFinish) {
            var finishMatched = (newProduct.variants || []).find(function (variant) {
              return variant.available && normalize(variant.title).indexOf(previousFinish) !== -1;
            }) || (newProduct.variants || []).find(function (variant) {
              return normalize(variant.title).indexOf(previousFinish) !== -1;
            });
            if (finishMatched) nextVariant = finishMatched;
          }
          state.product = newProduct;
          state.variant = nextVariant;
          state.selected = variantSelectedOptions(newProduct, nextVariant);
          updateCard(card, root);
        }).catch(function () {
          var status = root.querySelector('[data-room-status]');
          if (status) status.textContent = 'Could not load that colour. Please try again.';
        });
      });
      wrap.appendChild(button);
    });
  }

  function renderOptionControls(card, root) {
    var state = card._roomState;
    var wrap = card.querySelector('[data-room-options]');
    if (!wrap || !state || !state.product) return;

    var product = state.product;
    var optionRows = [];

    (product.options || []).forEach(function (_option, optionIndex) {
      var name = optionName(product, optionIndex);
      var values = [];
      (product.variants || []).forEach(function (variant) {
        var value = variantOptionValue(variant, optionIndex);
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      if (values.length > 1) {
        optionRows.push({ name: name, index: optionIndex, values: values });
      }
    });

    wrap.innerHTML = '';
    optionRows.forEach(function (option) {
      var row = document.createElement('div');
      row.className = 'bf-room-set__option-row';

      var label = document.createElement('div');
      label.className = 'bf-room-set__option-label';
      label.textContent = option.name;
      row.appendChild(label);

      var buttons = document.createElement('div');
      buttons.className = 'bf-room-set__option-buttons';

      option.values.forEach(function (value) {
        var button = document.createElement('button');
        var swatch = swatchAsset(value);
        button.type = 'button';
        button.className = swatch ? 'bf-room-set__swatch' : 'bf-room-set__choice';
        button.textContent = swatch ? '' : value;
        button.setAttribute('aria-label', value);
        if (swatch) setAssetBackground(button, swatch);
        button.classList.toggle('is-active', normalize(state.selected[option.name]) === normalize(value));
        button.addEventListener('click', function () {
          state.selected[option.name] = value;
          state.variant = findVariant(product, state.selected);
          state.selected = variantSelectedOptions(product, state.variant);
          updateCard(card, root);
        });
        buttons.appendChild(button);
      });

      row.appendChild(buttons);
      wrap.appendChild(row);
    });

    renderColourControls(card, root);
  }

  function initCard(card, root) {
    if (card.dataset.initialized === 'true') return;
    card.dataset.initialized = 'true';

    var handle = card.dataset.productHandle;
    var siblingsScript = card.querySelector('[data-room-siblings-json]');
    var siblings = {};
    try {
      siblings = siblingsScript ? JSON.parse(siblingsScript.textContent || '{}') : {};
    } catch (error) {
      siblings = {};
    }

    var checkbox = card.querySelector('[data-room-select]');
    var qtyInput = card.querySelector('[data-room-qty]');
    var qtyButtons = Array.prototype.slice.call(card.querySelectorAll('[data-room-qty-delta]'));

    function setQuantity(nextQty) {
      var qty = Math.max(0, Number(nextQty || 0));
      card.dataset.quantity = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (checkbox) checkbox.checked = qty > 0;
      updateCardTotals(root);
    }

    qtyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var current = Number(card.dataset.quantity || 0);
        var delta = Number(button.dataset.roomQtyDelta || 0);
        setQuantity(current + delta);
      });
    });

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked && Number(card.dataset.quantity || 0) === 0) {
          setQuantity(1);
        } else if (!checkbox.checked) {
          setQuantity(0);
        } else {
          updateCardTotals(root);
        }
      });
    }

    fetchProduct(handle).then(function (loadedProduct) {
      var variant = findDefaultVariant(loadedProduct, root._roomVariantDefaults && root._roomVariantDefaults[handle]) || firstAvailableVariant(loadedProduct);
      card._roomState = {
        product: loadedProduct,
        variant: variant,
        selected: variantSelectedOptions(loadedProduct, variant),
        siblings: siblings
      };
      updateCard(card, root);
    }).catch(function () {
      card.classList.add('has-load-error');
      var status = root.querySelector('[data-room-status]');
      if (status) status.textContent = 'Some collection products could not load. Refresh and try again.';
    });
  }

  function initGallery(root) {
    var main = root.querySelector('[data-room-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-room-gallery-thumb]'));
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (button) {
      button.addEventListener('click', function () {
        var image = button.dataset.image;
        if (!image) return;
        main.src = image;
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb === button);
          thumb.setAttribute('aria-pressed', thumb === button ? 'true' : 'false');
        });
      });
    });
  }

  function initRoomSet(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.documentElement.dataset.bfAssetBase = root.dataset.assetBase || '';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-room-card]'));
    var addButton = root.querySelector('[data-room-add]');
    var status = root.querySelector('[data-room-status]');
    var defaultScript = root.querySelector('[data-room-variant-defaults-json]');

    try {
      root._roomVariantDefaults = defaultScript ? JSON.parse(defaultScript.textContent || '{}') : {};
    } catch (error) {
      root._roomVariantDefaults = {};
    }

    initGallery(root);
    cards.forEach(function (card) {
      initCard(card, root);
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var items = cards.map(function (card) {
          var checkbox = card.querySelector('[data-room-select]');
          var qty = Number(card.dataset.quantity || 0);
          var state = card._roomState;
          if (!checkbox || !checkbox.checked || qty < 1 || !state || !state.variant || !state.variant.available) return null;
          return {
            id: Number(state.variant.id),
            quantity: qty,
            properties: {
              'Room collection': root.dataset.roomTitle || '',
              '_Room collection handle': root.dataset.roomHandle || ''
            }
          };
        }).filter(Boolean);

        if (!items.length) {
          if (status) status.textContent = 'Select at least one item.';
          return;
        }

        addButton.disabled = true;
        if (status) status.textContent = 'Adding selected items...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          window.location.href = '/cart';
        }).catch(function () {
          addButton.disabled = false;
          if (status) status.textContent = 'Could not add those items. Please try again.';
        });
      });
    }

    updateCardTotals(root);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-bf-room-set]')).forEach(initRoomSet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
